import type { IconBlockConfig } from '@lighthouse/core'
import { nanoid } from '@lighthouse/tools'

export const generateIconBlock = (mainBreakPoint: string): IconBlockConfig => {
    const actionId = nanoid()
    return {
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 24,
                    unit: 'px'
                },
                height: {
                    size: 'auto'
                }
            },
            icon: {
                type: 'icon',
                value: ''
            },
            design: {
                color: {
                    type: 'color',
                    color: '#98A2B3'
                }
            },
            layout: {}
        },
        breakPoints: [],
        content: {},
        eventList: []
    }
}
